<template>
    <solid-box title="土地承包经营权">
        <div class="list">
            <div class="item">
                <div class="body -one">
                    <div class="ring"></div>
                    <div class="ring"></div>
                    <div class="ring"></div>
                    <span class="text">{{ tradeSum.tdcbjyq.area || 0 }}</span>
                </div>
                <div class="footer">总面积(亩)</div>
            </div>
            <div class="item">
                <div class="body -two">
                    <div class="ring"></div>
                    <span class="text">{{
                        tradeSum.tdcbjyq.publishArea || 0
                    }}</span>
                </div>
                <div class="footer">总挂网(亩)</div>
            </div>
            <div class="item">
                <div class="body -three">
                    <div class="ring"></div>
                    <div class="ring"></div>
                    <span class="text">{{
                        tradeSum.tdcbjyq.transferArea || 0
                    }}</span>
                </div>
                <div class="footer">总成交(亩)</div>
            </div>
        </div>
    </solid-box>
</template>

<script>
import SolidBox from '@/components/SolidBox'

/**
 * 土地承包经营权
 */
export default {
    props: {
        tradeSum: {
            type: Object,
            default: () => {}
        }
    },
    created() {},
    components: {
        SolidBox
    }
}
</script>

<style lang="scss" scoped>
@keyframes lds-ring {
    0% {
        transform: rotate(135deg);
    }
    100% {
        transform: rotate(495deg);
    }
}

@keyframes lds-ring2 {
    0% {
        transform: rotate(45deg);
    }
    100% {
        transform: rotate(405deg);
    }
}

@keyframes lds-ring3 {
    0% {
        transform: rotate(225deg);
    }
    100% {
        transform: rotate(585deg);
    }
}

.list {
    display: flex;
    padding: 49px 50px 0;
    justify-content: space-between;

    > .item {
        > .body {
            width: 120px;
            height: 120px;
            position: relative;
            border-radius: 50%;
            box-sizing: border-box;
            text-align: center;
            font-size: 24px;
            text-align: center;
            line-height: 26px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 10px solid #fff;

            &.-one {
                border-color: #43481f;
                > .text {
                    background: rgba(255, 161, 6, 0.5);
                    border: 1px solid #bd7500;
                    box-shadow: 0 2px 4px 0 rgba(140, 91, 0, 0.6);
                }
                > .ring {
                    border-color: #ffa106 transparent transparent transparent;
                }

                > .ring.ring:nth-child(1) {
                    transform: rotate(45deg);
                    animation: lds-ring2 1.2s cubic-bezier(0.5, 0, 0.5, 1);
                    animation-delay: -0.45s;
                }

                > .ring:nth-child(2) {
                    transform: rotate(135deg);
                    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1);
                    animation-delay: -0.3s;
                }

                > .ring:nth-child(3) {
                    transform: rotate(225deg);
                    animation: lds-ring3 1.2s cubic-bezier(0.5, 0, 0.5, 1);
                    animation-delay: -0.15s;
                }
            }

            &.-two {
                color: #00af6c;
                border-color: #114a37;

                > .text {
                    background: rgba(0, 175, 108, 0.5);
                    border: 1px solid #00af6c;
                    box-shadow: 0 2px 4px 0 rgba(0, 75, 46, 0.6);
                }
                > .ring {
                    border-color: #00af6c transparent transparent transparent;
                    transform: rotate(45deg);
                    animation: lds-ring2 1.2s cubic-bezier(0.5, 0, 0.5, 1);
                }
            }

            &.-three {
                color: #0bf9d9;
                border-color: rgba(14, 133, 130, 0.56);

                > .ring {
                    border-color: #0bf9d9 transparent transparent transparent;
                }

                > .ring:nth-child(1) {
                    transform: rotate(45deg);
                    animation: lds-ring2 1.2s cubic-bezier(0.5, 0, 0.5, 1);
                    animation-delay: -0.3s;
                }

                > .ring:nth-child(2) {
                    transform: rotate(135deg);
                    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1);
                    animation-delay: -0.15s;
                }
            }

            > .ring {
                box-sizing: border-box;
                display: block;
                position: absolute;
                width: 120px;
                height: 120px;
                top: -10px;
                left: -10px;
                border: 10px solid #fff;
                border-radius: 50%;
            }

            > .text {
                color: #fff;
                position: absolute;
                display: block;
                white-space: nowrap;
                background: rgba(11, 249, 217, 0.5);
                border: 1px solid #0bf9d9;
                box-shadow: 0 2px 4px 0 rgba(0, 72, 62, 0.6);
                border-radius: 3px;
                border-radius: 3px;
                padding: 4px 0;
                width: 150px;
            }
        }

        > .footer {
            margin-top: 20px;
            font-size: 16px;
            color: #ffffff;
            text-align: center;
            line-height: 22px;
        }
    }
}
</style>
